import { render, staticRenderFns } from "./vanDetail.vue?vue&type=template&id=570eb86b&scoped=true&"
import script from "./vanDetail.vue?vue&type=script&lang=js&"
export * from "./vanDetail.vue?vue&type=script&lang=js&"
import style0 from "@/assets/components.scss?vue&type=style&index=0&id=570eb86b&lang=scss&scoped=true&"
import style1 from "./vanDetail.vue?vue&type=style&index=1&id=570eb86b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "570eb86b",
  null
  
)

export default component.exports